module.exports = __webpack_public_path__ + "img/HC2012-01.b229bfbe.jpg";